export default {
  message_top:100,      //提示语距离顶部默认距离
  message_duration:3,   //提示语默认展示时间
}